import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { T_SHIRT_SIZES, T_SHIRT_SIZE_DEFAULT } from '../../config';

import css from './index.module.css';
import LayoutPageWrapper from '../LayoutPageWrapper';

const Hero = ({ children, horizontalPadding, name }) => {
  const wrapperClasses = classnames(
    css.hero,
    {
      [css[`hero${name}`]]: name,
    },
  );

  return (
    <section className={wrapperClasses}>
      <LayoutPageWrapper horizontalPadding={horizontalPadding}>
        <div className={css.heroContentWrapper}>
          {children}
        </div>
      </LayoutPageWrapper>
    </section>
  );
}

Hero.propTypes = {
  children: PropTypes.node.isRequired,
  horizontalPadding: PropTypes.oneOf(T_SHIRT_SIZES),
  name: PropTypes.string,
};

Hero.defaultProps = {
  horizontalPadding: T_SHIRT_SIZE_DEFAULT,
  name: null,
};

export default Hero;
